import { mergeQueryKeys } from '@lukemorales/query-key-factory';
import { displayQueryKeys } from './display';
import { journeyQueryKeys } from './journey';
import { joyQueryKeys } from './joy';
import { listQueryKeys } from './list';
import { searchQueryKeys } from './search';
import { globalListQueryKeys } from './global-list';

export const queries = mergeQueryKeys(
  journeyQueryKeys,
  joyQueryKeys,
  listQueryKeys,
  searchQueryKeys,
  globalListQueryKeys,
  displayQueryKeys,
);
